// Local translations
export const T = {
  en_GB: {
    title: "Title (optional)",
    titlePlaceholder: "e.g., Historical Return",
    titleHelp: "Optional heading to display above the chart",
    description: "Description (optional)",
    descriptionPlaceholder: "Enter description...",
    descriptionHelp: "Optional text to display between the title and chart",
    componentDescription:
      "This component displays the goal portfolio's indexed historical return over time as a line chart.",
  },
  nb_NO: {
    title: "Tittel (valgfri)",
    titlePlaceholder: "f.eks. Historisk avkastning",
    titleHelp: "Valgfri overskrift som vises over diagrammet",
    description: "Beskrivelse (valgfri)",
    descriptionPlaceholder: "Skriv inn beskrivelse...",
    descriptionHelp: "Valgfri tekst som vises mellom tittelen og diagrammet",
    componentDescription:
      "Denne komponenten viser målets porteføljes indekserte historiske avkastning over tid som et linjediagram.",
  },
} as const;
